import { VObjectProperty } from './CalendarData'

export const VcalendarProperties: VObjectProperty[] = [
  ['prodid', {}, 'text', '-//Linagora//Twake-Calendar//EN'],
  ['version', {}, 'text', '2.0']
] as VObjectProperty[]
